import { Box, LinearProgress, Typography } from "@material-ui/core";
import NoTierLogo from "../../assets/images/noTierLogo.svg";
import FishLogo from '../../assets/images/fishes.png';
import PlanktonLogo from '../../assets/images/planktons.png';
import SharksLogo from '../../assets/images/sharks.png';
import DolphinLogo from '../../assets/images/dolphins.png';
import WhaleLogo from '../../assets/images/whales.png';
import useStyles from "../Styles/PopOverStyles";
import { useContext } from "react";
import AuthContext from "../../store/Auth/AuthContext";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import { nextTierRequirement, tierLevel } from "../../utils/constants/helpers";
import { TokenDollar } from "../../utils/currency/usd";

export const TierLevel = () => {

  const classes = useStyles();

  const { getProfileData, Logout } = useContext<any>(AuthContext);
  const { lockedGains, lockedGainsPad } = useContext<any>(SubscriptionContext);

  const tierLogo = (tier: number) => {
    switch (tier) {
      case 1:
        return WhaleLogo;
      case 2:
        return SharksLogo;
      case 3:
        return DolphinLogo;
      case 4:
        return FishLogo;
      case 5:
        return PlanktonLogo;
      default:
        return NoTierLogo;
    }
  }


  return (
    <Box padding={"0 0.5rem"}>
      {/* <Box mb={"0.875rem"} className={classes.smallProfileDivider}/> */}
      <Box 
        display={"flex"} 
        justifyContent="space-between" 
        alignItems={"center"}
        mb={".5rem"}
      >
        <Typography className={classes.tierLevel}>Next level:</Typography>
        <Typography 
          variant="body1" 
          color="secondary" 
          className={classes.listTitle}
        >
          {getProfileData?.learnpad_tier ?
          getProfileData?.learnpad_tier === 1 ? "Max Level" : tierLevel(getProfileData?.learnpad_tier -1)
          : "Planktons"}
        </Typography>
      </Box>
      <LinearProgress 
        variant="determinate" 
        value={getProfileData?.learnpad_tier === 1 ? 100 : (lockedGains / Number(nextTierRequirement(getProfileData?.learnpad_tier))) * 100} 
        className={classes.profileProgressBar}
      />
      <Box 
        display={"flex"} 
        justifyContent="space-between" 
        alignItems={"center"}
        mb={"0.875rem"}
      >
        <Typography className={classes.tierLevel}>
          <span style={{color:"rgba(17, 48, 45, 1)"}}>{TokenDollar(lockedGainsPad)}</span>
          /{getProfileData?.learnpad_tier === 1 ? "200,000" : TokenDollar(nextTierRequirement(getProfileData?.learnpad_tier))}
        </Typography>
        <Typography
          className={classes.tierLevel}
          style={{color:"rgba(17, 48, 45, 1)"}}
        >
          {getProfileData?.learnpad_tier === 1 ? 100 :
          getProfileData?.learnpad_tier ? Math.floor((lockedGains / nextTierRequirement(getProfileData?.learnpad_tier)) * 100) : 0}%
        </Typography>
      </Box>
    </Box>
  )
}

export default TierLevel;